import { useTranslation } from 'react-i18next';

import styles from './index.module.scss';

const VibeHubBrand = () => {
  const { i18n } = useTranslation();
  const isChinese = i18n.resolvedLanguage?.toLowerCase().startsWith('zh') ?? false;

  return (
    <>
      <header className={styles.topbar}>
        <div className={styles.brand} aria-label="VibeHub">
          <img src="/assets/vibehub-logo-approved-04.svg" alt="" />
          <img className={styles.wordmark} src="/assets/vibehub-wordmark-figma.svg" alt="VibeHub" />
        </div>
      </header>
      <aside className={styles.editorial} aria-labelledby="vibehub-auth-heading">
        <div>
          <h1 id="vibehub-auth-heading">
            {isChinese ? '继续创造' : 'Keep creating'}
            <span aria-hidden="true">。</span>
          </h1>
          <p className={styles.lead}>
            {isChinese
              ? '发现实时图形、生成影像和创意编程作品，持续成长。'
              : 'Discover real-time graphics, generative visuals, and creative code.'}
          </p>
        </div>
        <div className={styles.indexMark} aria-label="VibeHub creator index">
          <p className={styles.indexLine}>
            <i aria-hidden="true" /> VIBEHUB.DYNAMIC.CODE.INDEX
          </p>
          <p className={`${styles.indexLine} ${styles.indexSecondary}`}>OPEN FOR CREATORS</p>
          <ol>
            <li>00</li>
            <li>25</li>
            <li>50</li>
            <li>75</li>
            <li>100</li>
          </ol>
        </div>
      </aside>
    </>
  );
};

export default VibeHubBrand;
